import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// common components
import FontIcon from './../../../common/FontIcon/FontIcon';
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import Loader from './../../../common/Loader/Loader';
// css
import './UserTestList.scss';
import ModuleList from '../../CourseModule/ModuleList/ModuleList';

const UserTestList = ({ details, takeTestPage }) => {
	if (details && details.modules && details.modules.length > 0) {
		return (
			<div className='row UserTestList'>
				{details.modules.map(item => (
					<div className='col-sm-6 col-md-4' key={item.module_id}>
						<div className='test-card'>
							<div>
								<img src='./assets/images/jpeg/leadingsafeagile_bg2.jpg' />
								<div className='heading'>{item.module_name}</div>
								{item.user_attempts.length > 0 && item.user_attempts.map((score, i) => {
									if (score.testStatus === 'C') {
										return (
											<div className='test-score' key={i}>
												<div className='time'>
													<FontIcon iconName='calender' />
													<span>{moment(score.created_date).format('DD MMM YYYY')}</span>
												</div>
												<div className='score'>{score.result}</div>
											</div>
										);
									}
									if (score.testStatus === 'I') {
										return (
											<div className='test-score' key={i}>
												<div className='time'>
													<FontIcon iconName='calender' />
													<span>{moment(score.created_date).format('DD MMM YYYY')}</span>
												</div>
												<div className='score'>In Progress</div>
											</div>
										);
									}
									return null;
								})}
								{item.user_attempts && item.user_attempts.every(val => val.testStatus === 'N') &&
									<div className='loader-msg'>Take a test to see the score</div>}
							</div>
							<div className='action'>
								<CustomButton
									name={
										item.user_attempts && item.user_attempts.some(val => val.testStatus === 'I') ?
										'Continue' : 'take test'
									}
									disabled={item.user_attempts && item.user_attempts.length > 0 && item.user_attempts.every(val => val.complete === 'Y')}
									onClick={() => takeTestPage(details.user_id, item.module_id, item.user_attempts)}
								/>
							</div>
						</div>
					</div>
				))}
			</div>
		);
	}
	return (<Loader />);
}


UserTestList.propTypes = {
	history: PropTypes.instanceOf(Object),
	details: PropTypes.instanceOf(Object),
	takeTestPage: PropTypes.func
};

UserTestList.defaultProps = {
	history: {},
	details: {},
	takeTestPage: () => { }
};

export default UserTestList;



// WEBPACK FOOTER //
// ./components/Dashboard/UserTestList/UserTestList.js